export default "__VITE_ASSET__BqtSYLAs__"